import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as y from "yup";
import { TextField, ReadOnlyField } from "@/components/Form/Parts/index";
import { Button } from "@/components/Buttons";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var schema = y.object().shape({
  code: y.string().matches(/^\d{4}$/, "認証コードは4桁の数字を入力してください。").required("認証コードを入力してください。")
});
export default function Step2(_ref) {
  var _errors$code;

  var formData = _ref.formData,
      error = _ref.error,
      onSubmit = _ref.onSubmit;

  var _useForm = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  }),
      formState = _useForm.formState,
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors;

  var isDirty = formState.isDirty,
      isValid = formState.isValid,
      isSubmitting = formState.isSubmitting;
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsx("p", {
          className: processStyles.contentHeader,
          children: "\u4EE5\u4E0B\u306EE\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002"
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(ReadOnlyField, {
            className: formStyles.confirm,
            value: formData === null || formData === void 0 ? void 0 : formData.mailAddress
          })
        }), /*#__PURE__*/_jsxs("p", {
          className: formStyles.sentGuide,
          children: ["\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u5C4A\u3044\u305F", /*#__PURE__*/_jsx("span", {
            className: "fontBold",
            children: "4\u6841\u306E\u8A8D\u8A3C\u30B3\u30FC\u30C9"
          }), "\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u5C4A\u3044\u3066\u3044\u306A\u3044\u5834\u5408\u306F\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u6B63\u3057\u3044\u3053\u3068\u3084\u3001@skyperfectv.co.jp\u304B\u3089\u306E\u30E1\u30FC\u30EB\u304C\u8FF7\u60D1\u30E1\u30FC\u30EB\u306B\u5206\u985E\u3055\u308C\u3066\u3044\u306A\u3044\u304B\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u304D\u3001\u8FF7\u60D1\u30E1\u30FC\u30EB\u306B\u5206\u985E\u3055\u308C\u3066\u3044\u305F\u5834\u5408\u306F\u53D7\u4FE1\u8A31\u53EF\u306B\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"]
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(TextField, {
            ref: register,
            title: "\u8A8D\u8A3C\u30B3\u30FC\u30C9",
            type: "text",
            name: "code",
            placeholder: "4\u6841\u306E\u6570\u5B57",
            error: ((_errors$code = errors.code) === null || _errors$code === void 0 ? void 0 : _errors$code.message) || (error === null || error === void 0 ? void 0 : error.message),
            autoComplete: "off",
            required: true
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.btnArea,
      children: /*#__PURE__*/_jsx(Button, {
        type: "submit",
        fillColor: true,
        large: true,
        fontFixed: true,
        disabled: !isDirty || !isValid,
        loading: isSubmitting,
        children: "\u304A\u5BA2\u69D8\u60C5\u5831\u5165\u529B\u3078\u9032\u3080"
      })
    })]
  });
}